import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import DemoModal from "../Demomodal"; // adjust path if needed

function AuthCTA() {
  const navigate = useNavigate();
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <>
      <section className="py-24 bg-gradient-to-r from-[#2f5bea] to-[#1f3fbf] text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">

          <h2 className="text-5xl font-bold">
            Ready to Protect Your Brand?
          </h2>

          <p className="mt-6 text-lg text-blue-100">
            Join leading brands worldwide in the fight against counterfeits
          </p>

          <div className="mt-12 flex justify-center gap-6 flex-wrap">

            <button
              onClick={() => setDemoOpen(true)}
              className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold text-lg flex items-center gap-3 hover:scale-105 transition"
            >
              Schedule Demo →
            </button>

            <button
              onClick={() => navigate('/blog')}
              className="border border-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-white hover:text-blue-600 transition"
            >
              View Case Studies
            </button>

          </div>
        </div>
      </section>

      {demoOpen && <DemoModal initialTab={0} onClose={() => setDemoOpen(false)} />}
    </>
  );
}

export default AuthCTA;